import { generateTranslations } from '../i18n/translation';

const namespace = 'uhaStatuses';

const translations = generateTranslations(namespace, {
  deltOgHarKapasitet: {
    nb: 'Bestillingen er delt med praksissteder',
    en: 'Order is shared with practice places',
  },
  deltMenManglerKapasitet: {
    nb: 'Aktiviteten mangler praksisplasser',
    en: 'Activity is lacking capacity',
  },
  deltMedNoenPraksissteder: {
    nb: 'Bestillingen er ikke delt med alle praksissteder',
    en: 'Order has not been shared with all practice places',
  },
  gjennomfoert: {
    nb: 'Denne aktiviteten er gjennomført',
    en: 'This activity has been completed',
  },
  alleStudenterFordelt: {
    nb: 'Studentfordelingen er ikke delt med praksissteder',
    en: 'Student placement is not shared with practice places',
  },
  fordelingsresultatDelt: {
    nb: 'Studentfordelingen er delt med praksissted',
    en: 'Student assignments shared with practice places',
  },
  kanDeles: {
    nb: 'Bestillingen er ikke delt med praksissteder',
    en: 'Order is not shared with practice places',
  },
  manglerBehov: {
    nb: 'Mangler estimert behov',
    en: 'Missing estimated need',
  },
  studenterManglerKlasse: {
    nb: 'Noen studenter mangler praksisklasse',
    en: 'Some students are missing a practice class',
  },
  studenterManglerPlass: {
    nb: 'Noen studenter mangler praksisplass',
    en: 'Some students are not assigned to a practice place',
  },
  venterPaaOnskeliste: {
    nb: 'Ønskelisten er åpen for studentene',
    en: 'Wish list available for students',
  },
  avsluttetOnskeliste: {
    nb: 'Ønskelisteperioden er avsluttet',
    en: 'Wish list is closed',
  },
  aktiv: {
    nb: 'Aktiv',
    en: 'Active',
  },
  avtalefeil: {
    nb: 'Det finnes bestillinger/besvarelser som faller utenfor en avtale',
    en: 'There are orders/responses that are not connected to an agreement',
  },
});

export default translations;
